import { render, staticRenderFns } from "./edit_form_buttons.vue?vue&type=template&id=4c3a40d8&"
import script from "./edit_form_buttons.vue?vue&type=script&lang=js&"
export * from "./edit_form_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit_form_buttons.vue"
export default component.exports